import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  containerStyle,
  labelStyle,
  buttonGroupStyle,
  buttonStyle,
  activeButtonStyle,
  inactiveButtonStyle
} from './styles.ts';

import { Gender } from '@/enums/apiEnums.ts';

interface GenderFilterProps {
  initialGender?: string;
  onGenderChange: (gender: string) => void;
}

export const GenderFilter: FC<GenderFilterProps> = ({
  initialGender,
  onGenderChange
}) => {
  const { t } = useTranslation();
  const [searchGender, setSearchGender] = useState<string | undefined>(
    initialGender
  );

  const handleGenderChange = (gender: string) => {
    setSearchGender(gender);
    onGenderChange(gender);
  };

  return (
    <div style={containerStyle}>
      <div style={labelStyle}>{t('search_filters.show_me_gender')}</div>
      <div style={buttonGroupStyle}>
        <button
          onClick={() => handleGenderChange(Gender.FEMALE)}
          disabled={searchGender === Gender.FEMALE}
          style={{
            ...buttonStyle,
            ...(searchGender === Gender.FEMALE
              ? activeButtonStyle
              : inactiveButtonStyle)
          }}
        >
          {t('search_filters.show_me_female')}
        </button>
        <button
          onClick={() => handleGenderChange(Gender.MALE)}
          disabled={searchGender === Gender.MALE}
          style={{
            ...buttonStyle,
            ...(searchGender === Gender.MALE
              ? activeButtonStyle
              : inactiveButtonStyle)
          }}
        >
          {t('search_filters.show_me_male')}
        </button>
      </div>
    </div>
  );
};
